"use client";

import MaintenanceAnimation from "./lottie/maintenance.json";
import { LazyLottie } from "./ui/lazy-lottie";
import { ShinyText } from "./ui";

function Maintenance() {
  return (
    <>
      <title>維護中</title>
      <div className="bg-background flex h-screen flex-col items-center justify-center overflow-hidden p-4">
        <div className="w-75 relative my-4">
          <LazyLottie animationData={MaintenanceAnimation} loop autoplay />
        </div>
        <div className="px-6 pb-8">
          <ShinyText
            text="正在為您準備更好的體驗，趁機休息一下吧！"
            className="text-2xl font-black"
            color="oklch(0.6232 0.1567 277.75)"
            shineColor="oklch(0.8094 0.078 271.42)"
          />
        </div>
      </div>
    </>
  );
}

export { Maintenance };
